import StudentLandingModule from './containers/studentLandingModule'

export {default as StudentLandingModuleLayout} from './components/studentLandingModuleLayout'

export default StudentLandingModule
